var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgM2CGolf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.343764 20.4509L0.273193 20.9852H15.0845L15.2521 20.4509H0.343764Z",
    fill: "#78BA2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.464126 19.4248L0.393555 19.959H15.2049L15.3725 19.4248H0.464126Z",
    fill: "#FBB900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.132323 21.4839L0 22.0003L14.8113 21.9914L14.9877 21.4839H0.132323Z",
    fill: "#0769B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3319 8.20355H3.86396C3.61696 8.20355 3.41406 8.00766 3.41406 7.75835C3.41406 7.73164 3.41406 7.69603 3.42288 7.66932L3.77574 5.66595C3.81103 5.45226 3.99628 5.29199 4.21682 5.29199H15.3496C16.0994 5.29199 16.7169 5.91526 16.7081 6.67209C16.7081 6.72551 16.7081 6.77893 16.6992 6.83236L16.6904 6.98372C16.611 7.67822 16.0288 8.20355 15.3319 8.20355Z",
    fill: "#006AB3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3027 13.5014H2.49634L2.74334 12.1035C2.8933 11.2309 3.65195 10.5898 4.52528 10.5898H16.0462L15.9844 11.0885C15.8256 12.4686 14.67 13.5014 13.3027 13.5014Z",
    fill: "#006AB3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6001 18.4608L1.58838 18.5053L2.06474 15.7808H15.1117L14.6001 18.4608Z",
    fill: "#006AB3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11279 13.5014C5.64525 13.3946 5.18653 13.6795 5.06303 14.1425L4.80721 15.7808H2.06372L2.48715 13.5014H6.11279Z",
    fill: "#006AB3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.69 6.984L16.0372 10.5901L11.5029 11.0085L11.6353 10.5901H12.5439C13.0379 10.5901 13.4525 10.2161 13.5142 9.72638L13.6024 8.99627C13.6554 8.6045 13.3731 8.24835 12.9938 8.20383C12.9673 8.20383 12.932 8.19492 12.9055 8.19492H12.3851L12.7732 6.9751L16.69 6.984Z",
    fill: "#006AB3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3859 3.69143C14.834 1.43351 19.7833 0.582979 21.0325 0.7324L21.1785 1.4683L20.9449 1.42807C19.8122 1.21335 14.321 1.89506 9.19739 4.78165C8.54491 5.14911 7.79908 5.65383 7.11195 6.17957C6.363 6.76675 4.00405 8.82799 3.77979 10.0238C4.14064 7.6898 7.69129 5.05946 10.3859 3.69143Z",
    fill: "#679BC1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8785 7.32537C21.8785 7.32537 21.7246 8.30628 21.5456 9.1354C20.8296 9.7354 19.0868 10.8545 17.4544 11.4309C17.3305 10.5524 16.7779 10.3301 16.2245 9.69212C15.3281 8.65966 15.53 7.89283 16.7192 7.72385C20.2698 7.22122 21.1219 6.10212 21.8773 4.9415C23.2384 2.85366 22.8668 0.976318 22.8668 0.976318C24.8028 4.34149 21.3114 7.86021 20.2009 8.78814C20.3019 8.71726 20.962 8.28265 21.8778 7.32608L21.8785 7.32537Z",
    fill: "#0069B4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.342 3.59377C17.5744 3.48852 16.6322 4.07207 16.6186 4.97784C16.33 5.14109 16.8082 4.85397 16.6184 4.97784C16.6186 5.32572 17.1477 5.69028 17.295 6.0036C17.8929 6.02294 17.7091 5.83706 18.0828 5.55566H18.0835C18.0835 5.55566 17.7627 5.68874 17.2085 5.86273C17.3775 6.30881 17.5429 6.98269 17.7671 7.15024C18.6234 7.78749 19.4218 6.61824 19.5027 5.69028C19.6165 4.4172 19.2442 3.71765 18.342 3.59306V3.59377Z",
    fill: "#0069B4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 11.6927H17.397C17.561 11.629 17.7249 11.5624 17.8896 11.4922C21.5702 9.9305 24.7059 6.82282 25.4069 4.46484C25.7005 6.66458 23.8923 9.71496 21.4993 11.6927H21.5Z",
    fill: "#679BC1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0391 1.07568C23.0391 1.07568 24.7792 1.43022 25.2603 2.72622C26.2563 5.40914 22.0776 8.44004 22.0776 8.44004C22.0776 8.44004 25.6262 5.17142 24.7026 3.02909C24.3302 2.16486 23.3613 1.8991 23.3613 1.8991L23.0391 1.07568Z",
    fill: "#679BC1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83092 16.5765C6.6598 16.8195 6.42024 17.236 6.52318 17.8262C5.10355 17.4106 3.8487 15.9639 3.6431 15.5577C2.23932 12.7843 4.10998 9.72914 8.00072 7.56034C4.71667 9.62724 3.2133 12.1312 4.16039 14.2413C4.61536 15.2555 5.48363 16.2956 6.83092 16.5765Z",
    fill: "#679BC1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.953 18.3208C7.46127 18.3208 7.87329 17.9088 7.87329 17.4005C7.87329 16.8923 7.46127 16.4802 6.953 16.4802C6.44474 16.4802 6.03271 16.8923 6.03271 17.4005C6.03271 17.9088 6.44474 18.3208 6.953 18.3208Z",
    fill: "url(#paint0_linear_830_2503)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.09861 17.7827C7.09861 17.863 7.03339 17.9283 6.95385 17.9283C6.87431 17.9283 6.80908 17.863 6.80908 17.7827C6.80908 17.7024 6.87431 17.6379 6.95385 17.6379C7.03339 17.6379 7.09861 17.7032 7.09861 17.7827Z",
    fill: "url(#paint1_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.95446 17.6984C7.02446 17.6984 7.08332 17.7485 7.09763 17.8145C7.10002 17.805 7.10082 17.7946 7.10082 17.7843C7.10082 17.704 7.03559 17.6379 6.95446 17.6379C6.87333 17.6379 6.80811 17.7032 6.80811 17.7843C6.80811 17.7946 6.8089 17.805 6.81129 17.8145C6.82481 17.7485 6.88367 17.6984 6.95446 17.6984Z",
    fill: "url(#paint2_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.60442 17.7179C6.58692 17.7784 6.52328 17.8126 6.46283 17.7951C6.40238 17.7776 6.36818 17.714 6.38568 17.6535C6.40318 17.5931 6.46681 17.5589 6.52726 17.5764C6.58771 17.5939 6.62191 17.6575 6.60442 17.7179Z",
    fill: "url(#paint3_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.51467 17.6209C6.56717 17.636 6.59978 17.6869 6.5958 17.7394C6.59978 17.7323 6.60216 17.7251 6.60455 17.7179C6.62205 17.6575 6.58785 17.5939 6.5274 17.5764C6.46695 17.5589 6.40411 17.5931 6.38581 17.6535C6.38343 17.6615 6.38184 17.6686 6.38184 17.6766C6.40649 17.6296 6.46138 17.6058 6.51387 17.6209L6.51467 17.6209Z",
    fill: "url(#paint4_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.23924 17.5568C6.22493 17.6045 6.17959 17.6332 6.13743 17.6205C6.09528 17.6077 6.07221 17.5592 6.08653 17.5115C6.10084 17.4638 6.14618 17.4351 6.18834 17.4478C6.2305 17.4606 6.25356 17.5091 6.23924 17.5568Z",
    fill: "url(#paint5_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.17772 17.4836C6.21431 17.4948 6.23659 17.533 6.23181 17.5743C6.2342 17.5687 6.23659 17.5632 6.23897 17.5568C6.25329 17.5091 6.23022 17.4606 6.18807 17.4478C6.14591 17.4351 6.10057 17.4638 6.08625 17.5115C6.08466 17.5178 6.08307 17.5234 6.08228 17.5298C6.10137 17.4924 6.14034 17.4725 6.17693 17.4828L6.17772 17.4836Z",
    fill: "url(#paint6_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.30578 17.7179C7.32328 17.7784 7.38691 17.8126 7.44736 17.7951C7.50781 17.7776 7.54202 17.714 7.52452 17.6535C7.50702 17.5931 7.44339 17.5589 7.38373 17.5764C7.32328 17.5939 7.28908 17.6575 7.30658 17.7179L7.30578 17.7179Z",
    fill: "url(#paint7_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.39572 17.6209C7.34323 17.636 7.31062 17.6869 7.31459 17.7394C7.31062 17.7323 7.30823 17.7251 7.30584 17.7179C7.28834 17.6575 7.32255 17.5939 7.383 17.5764C7.44345 17.5589 7.50629 17.5931 7.52458 17.6535C7.52697 17.6615 7.52856 17.6686 7.52856 17.6766C7.5039 17.6296 7.44902 17.6058 7.39652 17.6209L7.39572 17.6209Z",
    fill: "url(#paint8_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.67002 17.5568C7.68434 17.6045 7.72968 17.6332 7.77183 17.6205C7.81399 17.6077 7.83706 17.5592 7.82274 17.5115C7.80842 17.4638 7.76309 17.4351 7.72093 17.4478C7.67877 17.4606 7.6557 17.5091 7.67002 17.5568Z",
    fill: "url(#paint9_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.73127 17.4836C7.69468 17.4948 7.67241 17.533 7.67718 17.5743C7.67479 17.5687 7.67241 17.5632 7.67002 17.5568C7.6557 17.5091 7.67877 17.4606 7.72093 17.4478C7.76309 17.4351 7.80842 17.4638 7.82274 17.5115C7.82433 17.5178 7.82592 17.5234 7.82672 17.5298C7.80763 17.4924 7.76865 17.4725 7.73206 17.4828L7.73127 17.4836Z",
    fill: "url(#paint10_linear_830_2503)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.06599 17.2437C7.06599 17.3065 7.01509 17.3582 6.95145 17.3582C6.88782 17.3582 6.83691 17.3073 6.83691 17.2437C6.83691 17.1801 6.88782 17.1292 6.95145 17.1292C7.01509 17.1292 7.06599 17.1801 7.06599 17.2437Z",
    fill: "url(#paint11_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.95158 17.1769C7.00726 17.1769 7.05339 17.2159 7.06373 17.2683C7.06532 17.2604 7.06612 17.2524 7.06612 17.2445C7.06612 17.1809 7.01442 17.1292 6.95078 17.1292C6.88715 17.1292 6.83545 17.1809 6.83545 17.2445C6.83545 17.2524 6.83625 17.2604 6.83784 17.2683C6.84897 17.2159 6.89511 17.1769 6.94999 17.1769L6.95158 17.1769Z",
    fill: "url(#paint12_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.67759 17.1955C6.66328 17.2432 6.61396 17.2703 6.56624 17.256C6.51851 17.2416 6.49147 17.1923 6.50579 17.1446C6.5201 17.0969 6.56942 17.0698 6.61714 17.0842C6.66487 17.0985 6.69191 17.1478 6.67759 17.1955Z",
    fill: "url(#paint13_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.60615 17.1199C6.64751 17.1318 6.67376 17.1716 6.66978 17.2129C6.67297 17.2074 6.67535 17.2018 6.67694 17.1954C6.69126 17.1477 6.66422 17.0976 6.61649 17.0841C6.56877 17.0698 6.51945 17.0976 6.50513 17.1445C6.50354 17.1509 6.50195 17.1565 6.50195 17.1628C6.52184 17.1262 6.56479 17.1072 6.60615 17.1191L6.60615 17.1199Z",
    fill: "url(#paint14_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.38786 17.0661C6.37672 17.1035 6.34093 17.1258 6.30752 17.1163C6.27412 17.1067 6.25662 17.0677 6.26775 17.0303C6.27889 16.993 6.31468 16.9707 6.34809 16.9802C6.3815 16.9898 6.399 17.0288 6.38786 17.0661Z",
    fill: "url(#paint15_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.33991 17.0081C6.36854 17.0168 6.38604 17.047 6.38286 17.0797C6.38524 17.0757 6.38683 17.0709 6.38842 17.0661C6.39956 17.0288 6.38127 16.9898 6.34865 16.9802C6.31525 16.9707 6.27945 16.993 6.26832 17.0303C6.26673 17.0351 6.26593 17.0399 6.26514 17.0447C6.28025 17.0152 6.31127 16.9993 6.33991 17.0081Z",
    fill: "url(#paint16_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.22893 17.1953C7.24325 17.243 7.29256 17.27 7.34029 17.2557C7.38801 17.2414 7.41506 17.1921 7.40074 17.1444C7.38642 17.0966 7.3371 17.0696 7.28938 17.0839C7.24166 17.0982 7.21461 17.1475 7.22893 17.1953Z",
    fill: "url(#paint17_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.29972 17.1196C7.25836 17.1316 7.23211 17.1713 7.23609 17.2127C7.23291 17.2071 7.23052 17.2016 7.22893 17.1952C7.21461 17.1475 7.24166 17.0974 7.28938 17.0838C7.3371 17.0695 7.38642 17.0974 7.40074 17.1443C7.40233 17.1507 7.40392 17.1562 7.40392 17.1626C7.38403 17.126 7.34108 17.1069 7.29972 17.1188L7.29972 17.1196Z",
    fill: "url(#paint18_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.51889 17.0661C7.53003 17.1035 7.56582 17.1258 7.59923 17.1163C7.63264 17.1067 7.65014 17.0677 7.639 17.0303C7.62787 16.993 7.59207 16.9707 7.55866 16.9802C7.52526 16.9898 7.50776 17.0288 7.5181 17.0661L7.51889 17.0661Z",
    fill: "url(#paint19_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.56766 17.0081C7.53903 17.0168 7.52153 17.047 7.52471 17.0797C7.52232 17.0757 7.52073 17.0709 7.51914 17.0661C7.508 17.0288 7.5263 16.9898 7.55891 16.9802C7.59232 16.9707 7.62811 16.993 7.63925 17.0303C7.64084 17.0351 7.64163 17.0399 7.64243 17.0447C7.62732 17.0152 7.59629 16.9993 7.56766 17.0081Z",
    fill: "url(#paint20_linear_830_2503)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.03335 16.8322C7.03335 16.876 6.99756 16.9118 6.95381 16.9118C6.91006 16.9118 6.87427 16.876 6.87427 16.8322C6.87427 16.7885 6.91006 16.7527 6.95381 16.7527C6.99756 16.7527 7.03335 16.7885 7.03335 16.8322Z",
    fill: "url(#paint21_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.9546 16.7861C6.99358 16.7861 7.0254 16.8131 7.03335 16.8497C7.03415 16.8442 7.03494 16.8386 7.03494 16.833C7.03494 16.7885 6.99915 16.7527 6.9546 16.7527C6.91006 16.7527 6.87427 16.7885 6.87427 16.833C6.87427 16.8386 6.87427 16.8442 6.87586 16.8497C6.88381 16.8131 6.91563 16.7861 6.9546 16.7861Z",
    fill: "url(#paint22_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.75935 16.7965C6.7498 16.8299 6.71481 16.8482 6.6814 16.8387C6.64799 16.8291 6.6297 16.7942 6.63924 16.7607C6.64879 16.7273 6.68378 16.709 6.71719 16.7186C6.7506 16.7281 6.76889 16.7631 6.75935 16.7965Z",
    fill: "url(#paint23_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.7099 16.7432C6.73853 16.7519 6.75683 16.779 6.75444 16.8084C6.75683 16.8044 6.75842 16.8005 6.75921 16.7965C6.76876 16.7631 6.75046 16.7281 6.71706 16.7185C6.68365 16.709 6.64945 16.7281 6.6391 16.7607C6.63751 16.7647 6.63672 16.7694 6.63672 16.7734C6.65024 16.748 6.68047 16.7344 6.7099 16.7432Z",
    fill: "url(#paint24_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.55879 16.7118C6.55084 16.738 6.52618 16.7539 6.50311 16.7468C6.48005 16.7396 6.46732 16.7134 6.47527 16.6871C6.48323 16.6609 6.50789 16.6449 6.53095 16.6521C6.55402 16.6593 6.56675 16.6855 6.55879 16.7118Z",
    fill: "url(#paint25_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.52454 16.6712C6.54442 16.6776 6.55715 16.6982 6.55476 16.7213C6.55636 16.7181 6.55795 16.7149 6.55874 16.7118C6.5667 16.6855 6.55397 16.6585 6.5309 16.6521C6.50784 16.6449 6.48238 16.6609 6.47522 16.6871C6.47443 16.6903 6.47363 16.6935 6.47363 16.6974C6.48397 16.6768 6.50545 16.6656 6.52613 16.672L6.52454 16.6712Z",
    fill: "url(#paint26_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.14681 16.7963C7.15635 16.8297 7.19135 16.848 7.22476 16.8385C7.25817 16.8289 7.27646 16.7939 7.26692 16.7605C7.25737 16.7271 7.22237 16.7088 7.18897 16.7183C7.15556 16.7279 7.13726 16.7629 7.14681 16.7963Z",
    fill: "url(#paint27_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.19613 16.7429C7.16749 16.7517 7.1492 16.7787 7.15158 16.8082C7.1492 16.8042 7.14761 16.8002 7.14681 16.7962C7.13726 16.7628 7.15556 16.7278 7.18897 16.7183C7.22237 16.7087 7.25658 16.7278 7.26692 16.7604C7.26851 16.7644 7.2693 16.7692 7.2693 16.7732C7.25578 16.7477 7.22556 16.7342 7.19613 16.7429Z",
    fill: "url(#paint28_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.34857 16.712C7.35652 16.7383 7.38118 16.7542 7.40424 16.747C7.42731 16.7398 7.44004 16.7136 7.43208 16.6873C7.42413 16.6611 7.39947 16.6452 7.37641 16.6524C7.35334 16.6595 7.34061 16.6858 7.34857 16.712Z",
    fill: "url(#paint29_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.38277 16.6714C7.36288 16.6778 7.35016 16.6985 7.35254 16.7216C7.35095 16.7184 7.34936 16.7152 7.34857 16.712C7.34061 16.6858 7.35334 16.6587 7.37641 16.6524C7.39947 16.6452 7.42492 16.6611 7.43208 16.6873C7.43288 16.6905 7.43367 16.6937 7.43367 16.6977C7.42333 16.677 7.40186 16.6659 7.38118 16.6722L7.38277 16.6714Z",
    fill: "url(#paint30_linear_830_2503)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.8438 17.4579C6.8438 17.5184 6.79449 17.5677 6.73403 17.5677C6.67358 17.5677 6.62427 17.5184 6.62427 17.4579C6.62427 17.3975 6.67358 17.3481 6.73403 17.3481C6.79449 17.3481 6.8438 17.3975 6.8438 17.4579Z",
    fill: "url(#paint31_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.73483 17.3943C6.78812 17.3943 6.83267 17.4317 6.84301 17.4818C6.8446 17.4746 6.84539 17.4667 6.84539 17.4587C6.84539 17.3975 6.79608 17.3481 6.73483 17.3481C6.67358 17.3481 6.62427 17.3975 6.62427 17.4587C6.62427 17.4667 6.62506 17.4738 6.62665 17.4818C6.63699 17.4317 6.68154 17.3943 6.73483 17.3943Z",
    fill: "url(#paint32_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.28301 17.4586C7.28301 17.5191 7.23369 17.5684 7.17324 17.5684C7.11279 17.5684 7.06348 17.5191 7.06348 17.4586C7.06348 17.3982 7.11279 17.3489 7.17324 17.3489C7.23369 17.3489 7.28301 17.3982 7.28301 17.4586Z",
    fill: "url(#paint33_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.17404 17.395C7.22733 17.395 7.27187 17.4324 7.28221 17.4825C7.28381 17.4753 7.2846 17.4674 7.2846 17.4594C7.2846 17.3982 7.23529 17.3489 7.17404 17.3489C7.11279 17.3489 7.06348 17.3982 7.06348 17.4594C7.06348 17.4674 7.06427 17.4746 7.06586 17.4825C7.0762 17.4324 7.12075 17.395 7.17404 17.395Z",
    fill: "url(#paint34_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.46722 17.4018C6.4537 17.4471 6.40677 17.4726 6.36143 17.4599C6.31609 17.4463 6.29064 17.3994 6.30416 17.3541C6.31768 17.3087 6.36461 17.2833 6.40995 17.296C6.45529 17.3095 6.48074 17.3564 6.46722 17.4018Z",
    fill: "url(#paint35_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.39923 17.3297C6.439 17.3416 6.46366 17.379 6.45968 17.4188C6.46207 17.414 6.46445 17.4084 6.46605 17.4021C6.47957 17.3567 6.45332 17.309 6.40878 17.2963C6.36344 17.2828 6.31651 17.309 6.30299 17.3543C6.3014 17.3599 6.3006 17.3663 6.2998 17.3718C6.31889 17.3368 6.35946 17.3186 6.39923 17.3305L6.39923 17.3297Z",
    fill: "url(#paint36_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.19271 17.2906C6.18158 17.3272 6.14658 17.3494 6.11476 17.3399C6.08295 17.3303 6.06465 17.2929 6.07579 17.2564C6.08692 17.2198 6.12192 17.1975 6.15374 17.207C6.18635 17.2166 6.20385 17.254 6.19271 17.2906Z",
    fill: "url(#paint37_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.14489 17.2341C6.17353 17.242 6.19023 17.2723 6.18705 17.3041C6.18944 17.3001 6.19103 17.2953 6.19262 17.2906C6.20375 17.254 6.18625 17.2166 6.15364 17.207C6.12103 17.1975 6.08603 17.2198 6.0749 17.2564C6.07331 17.2611 6.07251 17.2659 6.07251 17.2707C6.08683 17.242 6.11705 17.2261 6.14569 17.2349L6.14489 17.2341Z",
    fill: "url(#paint38_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.44102 17.4023C7.45454 17.4476 7.50147 17.4731 7.54681 17.4603C7.59214 17.4468 7.6176 17.3999 7.60487 17.3545C7.59214 17.3092 7.54442 17.2838 7.49908 17.2965C7.45374 17.31 7.42829 17.3569 7.44102 17.4023Z",
    fill: "url(#paint39_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.50958 17.3302C7.46981 17.3421 7.44516 17.3795 7.44913 17.4193C7.44675 17.4145 7.44436 17.4089 7.44277 17.4026C7.42925 17.3572 7.4555 17.3095 7.50004 17.2968C7.54538 17.2832 7.59231 17.3095 7.60583 17.3548C7.60742 17.3604 7.60822 17.3668 7.60901 17.3723C7.58992 17.3373 7.54936 17.319 7.50958 17.331L7.50958 17.3302Z",
    fill: "url(#paint40_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.71544 17.2906C7.72657 17.3272 7.76157 17.3494 7.79339 17.3399C7.826 17.3303 7.8435 17.2929 7.83236 17.2564C7.82122 17.2198 7.78623 17.1975 7.75441 17.207C7.72259 17.2166 7.7043 17.254 7.71544 17.2906Z",
    fill: "url(#paint41_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.76202 17.2341C7.73338 17.242 7.71668 17.2723 7.71986 17.3041C7.71747 17.3001 7.71588 17.2953 7.71429 17.2906C7.70316 17.254 7.72066 17.2166 7.75327 17.207C7.78588 17.1975 7.82088 17.2198 7.83201 17.2564C7.8336 17.2611 7.8344 17.2659 7.8344 17.2707C7.82008 17.242 7.78986 17.2261 7.76122 17.2349L7.76202 17.2341Z",
    fill: "url(#paint42_linear_830_2503)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.78567 17.084C6.83179 17.084 6.86918 17.0466 6.86918 17.0005C6.86918 16.9544 6.83179 16.917 6.78567 16.917C6.73954 16.917 6.70215 16.9544 6.70215 17.0005C6.70215 17.0466 6.73954 17.084 6.78567 17.084Z",
    fill: "url(#paint43_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.78646 16.952C6.82703 16.952 6.86123 16.9806 6.86918 17.0188C6.86998 17.0132 6.87078 17.0077 6.87078 17.0013C6.87078 16.9544 6.83339 16.917 6.78646 16.917C6.73953 16.917 6.70215 16.9544 6.70215 17.0013C6.70215 17.0069 6.70215 17.0132 6.70374 17.0188C6.71169 16.9806 6.7459 16.952 6.78646 16.952Z",
    fill: "url(#paint44_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.12063 17.084C7.16675 17.084 7.20415 17.0466 7.20415 17.0005C7.20415 16.9544 7.16675 16.917 7.12063 16.917C7.0745 16.917 7.03711 16.9544 7.03711 17.0005C7.03711 17.0466 7.0745 17.084 7.12063 17.084Z",
    fill: "url(#paint45_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.12069 16.952C7.16126 16.952 7.19546 16.9806 7.20341 17.0188C7.20421 17.0132 7.205 17.0077 7.205 17.0013C7.205 16.9544 7.16762 16.917 7.12069 16.917C7.07376 16.917 7.03638 16.9544 7.03638 17.0013C7.03638 17.0069 7.03638 17.0132 7.03797 17.0188C7.04592 16.9806 7.08012 16.952 7.12069 16.952Z",
    fill: "url(#paint46_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.58294 16.9603C6.5726 16.9945 6.53681 17.0144 6.50181 17.0041C6.46761 16.9937 6.44772 16.9579 6.45806 16.923C6.4684 16.8887 6.50419 16.8689 6.5384 16.8792C6.5726 16.8895 6.59249 16.9253 6.58215 16.9603L6.58294 16.9603Z",
    fill: "url(#paint47_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.53022 16.9054C6.56044 16.9142 6.57874 16.9428 6.57635 16.9731C6.57874 16.9691 6.58033 16.9651 6.58112 16.9603C6.59146 16.9261 6.57158 16.8895 6.53738 16.8792C6.50317 16.8689 6.46658 16.8887 6.45624 16.9237C6.45465 16.9285 6.45386 16.9325 6.45386 16.9373C6.46817 16.9102 6.4992 16.8967 6.52942 16.9054L6.53022 16.9054Z",
    fill: "url(#paint48_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.37146 16.8734C6.3635 16.9012 6.33646 16.9179 6.3118 16.9108C6.28714 16.9036 6.27362 16.875 6.28158 16.8471C6.28953 16.8193 6.31657 16.8026 6.34123 16.8098C6.36589 16.8169 6.37941 16.8456 6.37146 16.8734Z",
    fill: "url(#paint49_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.33577 16.8304C6.35725 16.8368 6.36997 16.8591 6.36759 16.8837C6.36918 16.8806 6.37077 16.8774 6.37156 16.8734C6.37952 16.8456 6.36679 16.8169 6.34134 16.8098C6.31668 16.8026 6.28964 16.8193 6.28168 16.8471C6.28089 16.8503 6.28009 16.8543 6.2793 16.8575C6.29043 16.836 6.3135 16.8241 6.33498 16.8304L6.33577 16.8304Z",
    fill: "url(#paint50_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.32305 16.9601C7.33339 16.9943 7.36919 17.0142 7.40339 17.0038C7.43759 16.9935 7.45748 16.9577 7.44713 16.9227C7.43679 16.8885 7.401 16.8686 7.3668 16.879C7.3326 16.8893 7.31271 16.9251 7.32305 16.9601Z",
    fill: "url(#paint51_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.37396 16.9052C7.34373 16.914 7.32544 16.9426 7.32782 16.9728C7.32544 16.9688 7.32385 16.9649 7.32305 16.9601C7.31271 16.9259 7.3326 16.8893 7.3668 16.879C7.401 16.8686 7.43759 16.8885 7.44793 16.9235C7.44952 16.9283 7.45032 16.9322 7.45032 16.937C7.436 16.91 7.40498 16.8965 7.37475 16.9052L7.37396 16.9052Z",
    fill: "url(#paint52_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.53353 16.8734C7.54148 16.9012 7.56853 16.9179 7.59319 16.9108C7.61784 16.9036 7.63137 16.875 7.62341 16.8471C7.61546 16.8193 7.58841 16.8026 7.56376 16.8098C7.5391 16.8169 7.52558 16.8456 7.53353 16.8734Z",
    fill: "url(#paint53_linear_830_2503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.57013 16.8304C7.54865 16.8368 7.53593 16.8591 7.53831 16.8837C7.53672 16.8806 7.53513 16.8774 7.53434 16.8734C7.52638 16.8456 7.53911 16.8169 7.56456 16.8098C7.58922 16.8026 7.61626 16.8193 7.62422 16.8471C7.62501 16.8503 7.62581 16.8543 7.6266 16.8575C7.61547 16.836 7.5924 16.8241 7.57093 16.8304L7.57013 16.8304Z",
    fill: "url(#paint54_linear_830_2503)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1,
    d: "M3.17175 16.3596C2.69689 16.3596 2.30714 16.0001 2.25703 15.5396C2.25385 15.5722 2.25146 15.6056 2.25146 15.639C2.25146 16.1472 2.66349 16.5593 3.17175 16.5593C3.68002 16.5593 4.09204 16.1472 4.09204 15.639C4.09204 15.6056 4.09045 15.5722 4.08648 15.5396C4.03637 16.0009 3.64661 16.3596 3.17175 16.3596Z",
    fill: "url(#paint55_linear_830_2503)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2249 0.0876072C22.6815 0.215613 22.7943 0.894628 22.8202 1.2545L22.822 1.25591C22.8672 1.88722 22.7131 2.78712 22.7131 2.78712C22.7059 2.47384 22.5467 1.99678 22.1898 1.83457C21.894 1.70044 21.5387 1.74912 21.2928 1.45218C21.2632 1.41643 21.2377 1.37884 21.2155 1.34024C20.9942 0.8451 20.8862 -0.098627 22.2249 0.0876072Z",
    fill: "#0069B4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_830_2503",
    x1: 6.953,
    y1: 16.4953,
    x2: 6.953,
    y2: 18.2906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FAFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EFF6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#DEECFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C5DEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_830_2503",
    x1: 6.66034,
    y1: 16.4854,
    x2: 6.87749,
    y2: 17.4455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_830_2503",
    x1: 6.66016,
    y1: 16.4862,
    x2: 6.8781,
    y2: 17.4455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_830_2503",
    x1: 6.51132,
    y1: 17.4458,
    x2: 6.44823,
    y2: 18.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_830_2503",
    x1: 6.53323,
    y1: 17.4598,
    x2: 6.47019,
    y2: 18.4413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_830_2503",
    x1: 6.19911,
    y1: 17.1733,
    x2: 6.16228,
    y2: 18.1499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_830_2503",
    x1: 6.18729,
    y1: 17.1686,
    x2: 6.1533,
    y2: 18.1446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_830_2503",
    x1: 7.37054,
    y1: 17.006,
    x2: 7.43341,
    y2: 17.9875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_830_2503",
    x1: 7.75865,
    y1: 16.8425,
    x2: 7.81975,
    y2: 17.8244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_830_2503",
    x1: 7.36781,
    y1: 17.0243,
    x2: 7.40464,
    y2: 18.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_830_2503",
    x1: 7.7849,
    y1: 16.8445,
    x2: 7.81911,
    y2: 17.8213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_830_2503",
    x1: 6.77408,
    y1: 16.4578,
    x2: 6.99122,
    y2: 17.4179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_830_2503",
    x1: 6.77341,
    y1: 16.4578,
    x2: 6.99055,
    y2: 17.4171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_830_2503",
    x1: 6.57383,
    y1: 17.4515,
    x2: 6.51096,
    y2: 18.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_830_2503",
    x1: 6.59597,
    y1: 17.4655,
    x2: 6.53293,
    y2: 18.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_830_2503",
    x1: 6.32137,
    y1: 17.1773,
    x2: 6.28454,
    y2: 18.1539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_830_2503",
    x1: 6.30828,
    y1: 17.1714,
    x2: 6.27515,
    y2: 18.1475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_830_2503",
    x1: 7.30334,
    y1: 17.0107,
    x2: 7.36621,
    y2: 17.9923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_830_2503",
    x1: 7.69222,
    y1: 16.8486,
    x2: 7.75309,
    y2: 17.8297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_830_2503",
    x1: 7.24304,
    y1: 17.0283,
    x2: 7.27987,
    y2: 18.0049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_830_2503",
    x1: 7.66169,
    y1: 16.8472,
    x2: 7.6959,
    y2: 17.8241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_830_2503",
    x1: 6.86472,
    y1: 16.4409,
    x2: 7.08267,
    y2: 17.4001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_830_2503",
    x1: 6.86552,
    y1: 16.4417,
    x2: 7.08266,
    y2: 17.4009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_830_2503",
    x1: 6.65684,
    y1: 17.4567,
    x2: 6.59375,
    y2: 18.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_830_2503",
    x1: 6.6787,
    y1: 17.4699,
    x2: 6.61543,
    y2: 18.4522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_830_2503",
    x1: 6.47819,
    y1: 17.1895,
    x2: 6.44136,
    y2: 18.1661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_830_2503",
    x1: 6.46521,
    y1: 17.1834,
    x2: 6.43123,
    y2: 18.1595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_830_2503",
    x1: 7.22098,
    y1: 17.0167,
    x2: 7.28385,
    y2: 17.9982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_830_2503",
    x1: 7.61042,
    y1: 16.8527,
    x2: 7.67152,
    y2: 17.8346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_830_2503",
    x1: 7.0866,
    y1: 17.0399,
    x2: 7.12365,
    y2: 18.0173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_830_2503",
    x1: 7.50529,
    y1: 16.8596,
    x2: 7.5395,
    y2: 17.8364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_830_2503",
    x1: 6.52166,
    y1: 16.5193,
    x2: 6.73881,
    y2: 17.4786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_830_2503",
    x1: 6.52166,
    y1: 16.5201,
    x2: 6.73881,
    y2: 17.4794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_830_2503",
    x1: 6.93939,
    y1: 16.4254,
    x2: 7.15654,
    y2: 17.3847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_830_2503",
    x1: 6.94019,
    y1: 16.4262,
    x2: 7.15734,
    y2: 17.3855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_830_2503",
    x1: 6.38213,
    y1: 17.4376,
    x2: 6.31926,
    y2: 18.4192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_830_2503",
    x1: 6.40299,
    y1: 17.4517,
    x2: 6.33972,
    y2: 18.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_830_2503",
    x1: 6.14634,
    y1: 17.1743,
    x2: 6.10929,
    y2: 18.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_830_2503",
    x1: 6.13525,
    y1: 17.1697,
    x2: 6.10105,
    y2: 18.1465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_830_2503",
    x1: 7.49491,
    y1: 16.9621,
    x2: 7.55801,
    y2: 17.9444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_830_2503",
    x1: 7.87379,
    y1: 16.8058,
    x2: 7.93466,
    y2: 17.7869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_830_2503",
    x1: 7.4259,
    y1: 17.0024,
    x2: 7.46273,
    y2: 17.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_830_2503",
    x1: 7.83097,
    y1: 16.829,
    x2: 7.86496,
    y2: 17.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_830_2503",
    x1: 6.66874,
    y1: 16.4835,
    x2: 6.88589,
    y2: 17.4428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_830_2503",
    x1: 6.66954,
    y1: 16.4835,
    x2: 6.88668,
    y2: 17.4436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_830_2503",
    x1: 6.987,
    y1: 16.4111,
    x2: 7.20415,
    y2: 17.3704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_830_2503",
    x1: 6.98706,
    y1: 16.4119,
    x2: 7.205,
    y2: 17.3712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_830_2503",
    x1: 6.48921,
    y1: 17.445,
    x2: 6.42612,
    y2: 18.4273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_830_2503",
    x1: 6.5092,
    y1: 17.4596,
    x2: 6.44616,
    y2: 18.4411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_830_2503",
    x1: 6.3029,
    y1: 17.1784,
    x2: 6.26585,
    y2: 18.1558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_830_2503",
    x1: 6.29103,
    y1: 17.1735,
    x2: 6.25704,
    y2: 18.1495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_830_2503",
    x1: 7.38638,
    y1: 16.9688,
    x2: 7.44871,
    y2: 17.9513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_830_2503",
    x1: 7.7645,
    y1: 16.8118,
    x2: 7.82561,
    y2: 17.7938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_830_2503",
    x1: 7.26698,
    y1: 17.0065,
    x2: 7.30381,
    y2: 17.9831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_830_2503",
    x1: 7.67317,
    y1: 16.832,
    x2: 7.70738,
    y2: 17.8088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_830_2503",
    x1: 3.17175,
    y1: 16.1823,
    x2: 3.17175,
    y2: 16.5219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM2CGolf);
export default __webpack_public_path__ + "static/media/m2c-golf.4ac5a393eac3789115157bdc1ec2b543.svg";
export { ForwardRef as ReactComponent };